module.exports = __webpack_public_path__ + "img/downLoad.95296b46.png";